export const isDev = /^dbg|localhost/.test(location.hostname)
// 这个由外部注入
const WKLink = (window as any).WKLink || {}
const api =
  (WKLink.getApi &&
    WKLink.getApi(
      location.hostname,
      isDev ? 'dev' : 'prod'
    )) ||
  {}

export const Config = isDev
  ? {
    BASE_URL: api.main || 'https://apiv1.lizhiweike.com',
    GATEWAY_NEW_URL: 'https://api.dev5.weike.fm'
  }
  : {
    BASE_URL: api.main || 'https://apiv1.lizhiweike.com',
    GATEWAY_NEW_URL: api.apiGw || 'https://api-gw.lizhiweike.com'
  }
